"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.createLocationLinkOrTextCellFormatter = exports.createLinkOrTextCellFormatter = exports.createLinkCellFormatter = exports.linkContents = exports.cellClickingTelemetryContext = exports.LinkCellFormatter = exports.noPaddingLinkCellClass = exports.linkCellClass = void 0;
var data_catalog_shared_1 = require("@tableau/data-catalog-shared");
var widgets_1 = require("@tableau/widgets");
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var Localize_1 = require("../../../../gen-src/Localize");
var LocationTypes_1 = require("../../sharedDisplayGrid/types/LocationTypes");
exports.linkCellClass = (0, data_catalog_shared_1.cssClass)('linkCell', data_catalog_shared_1.elideTextStyle, data_catalog_shared_1.cellPaddingStyle, { display: 'flex' });
exports.noPaddingLinkCellClass = (0, data_catalog_shared_1.cssClass)('noPaddingLinkCell', data_catalog_shared_1.elideTextStyle, { display: 'flex' });
var linkContainerClass = (0, data_catalog_shared_1.cssClass)('linkContainerClass', {
    textOverflow: 'ellipsis',
    overflow: 'hidden'
});
var disabledLinkContainerClass = (0, data_catalog_shared_1.cssClass)('linkContainerClass', {
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    pointerEvents: 'none',
    opacity: 0.6,
});
var postIconClass = (0, data_catalog_shared_1.cssClass)('postIconClass', {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    paddingLeft: '8px',
});
var locationCellCssClass = (0, data_catalog_shared_1.cssClass)('locationCell', {
    fontStyle: 'italic',
    color: widgets_1.TabStyles.Typography.Color.Secondary,
});
function LinkCellFormatter(_a) {
    var text = _a.text, pathname = _a.pathname, noPadding = _a.noPadding, _b = _a.targetBlank, targetBlank = _b === void 0 ? false : _b, _c = _a.useAnchor, useAnchor = _c === void 0 ? false : _c, _d = _a.postIcon, postIcon = _d === void 0 ? null : _d, _e = _a.linkTitle, linkTitle = _e === void 0 ? null : _e, _f = _a.disableTabIndex, disableTabIndex = _f === void 0 ? false : _f, _g = _a.disabled, disabled = _g === void 0 ? false : _g;
    return (react_1.default.createElement("div", { className: noPadding ? exports.noPaddingLinkCellClass : exports.linkCellClass },
        react_1.default.createElement("div", { className: disabled ? disabledLinkContainerClass : linkContainerClass }, useAnchor
            ? anchorContents({ text: text, pathname: pathname, noPadding: noPadding, targetBlank: targetBlank, postIcon: postIcon, linkTitle: linkTitle, disableTabIndex: disableTabIndex })
            : linkContents({ text: text, pathname: pathname, noPadding: noPadding, targetBlank: targetBlank, postIcon: postIcon, linkTitle: linkTitle, disableTabIndex: disableTabIndex })),
        postIcon
            ? react_1.default.createElement("div", { className: postIconClass }, postIcon)
            : null));
}
exports.LinkCellFormatter = LinkCellFormatter;
function anchorContents(_a) {
    var _b;
    var text = _a.text, pathname = _a.pathname, targetBlank = _a.targetBlank, linkTitle = _a.linkTitle, disableTabIndex = _a.disableTabIndex;
    return (react_1.default.createElement("a", { className: data_catalog_shared_1.linkClass, href: pathname, title: (_b = linkTitle !== null && linkTitle !== void 0 ? linkTitle : text) !== null && _b !== void 0 ? _b : undefined, target: targetBlank ? '_blank' : undefined, tabIndex: disableTabIndex ? -1 : 0, rel: "noreferrer" }, text));
}
exports.cellClickingTelemetryContext = react_1.default.createContext(function (telemetryHandler) {
    return telemetryHandler(function () { return react_1.default.createElement(react_1.default.Fragment, null); });
});
function linkContents(_a) {
    var text = _a.text, pathname = _a.pathname, targetBlank = _a.targetBlank, linkTitle = _a.linkTitle, disableTabIndex = _a.disableTabIndex;
    return (react_1.default.createElement(exports.cellClickingTelemetryContext.Consumer, null, function (telemetryHandler) { return telemetryHandler(function (onMouseUp) {
        var _a;
        return react_1.default.createElement(react_router_dom_1.Link, { onMouseUp: onMouseUp, className: data_catalog_shared_1.linkClass, to: pathname, title: (_a = linkTitle !== null && linkTitle !== void 0 ? linkTitle : text) !== null && _a !== void 0 ? _a : undefined, target: targetBlank ? '_blank' : undefined, tabIndex: disableTabIndex ? -1 : 0 }, text);
    }); }));
}
exports.linkContents = linkContents;
function createLinkCellFormatter(getTextFromRowData, getPathFromRowData, noPadding, useAnchor, disableTabIndex, getIconFromRowData, getLinkTitleFromRowData, getDisabledFromRowData) {
    if (noPadding === void 0) { noPadding = false; }
    if (useAnchor === void 0) { useAnchor = false; }
    if (disableTabIndex === void 0) { disableTabIndex = false; }
    if (getIconFromRowData === void 0) { getIconFromRowData = function () { return null; }; }
    if (getLinkTitleFromRowData === void 0) { getLinkTitleFromRowData = function () { return null; }; }
    return function (props) { return (react_1.default.createElement(data_catalog_shared_1.SiteUrlsContext.Consumer, null, function (urls) {
        return react_1.default.createElement(LinkCellFormatter, { text: getTextFromRowData(props.row.data), pathname: getPathFromRowData(urls, props.row.data), noPadding: noPadding, useAnchor: useAnchor, postIcon: getIconFromRowData(props.row.data), linkTitle: getLinkTitleFromRowData(props.row.data), disableTabIndex: disableTabIndex, disabled: getDisabledFromRowData ? getDisabledFromRowData(props.row.data) : false });
    })); };
}
exports.createLinkCellFormatter = createLinkCellFormatter;
function createLinkOrTextCellFormatter(getTextFromRowData, getPathFromRowData, noPadding, targetBlank, useAnchor) {
    if (noPadding === void 0) { noPadding = false; }
    if (targetBlank === void 0) { targetBlank = false; }
    if (useAnchor === void 0) { useAnchor = false; }
    return function (props) { return (react_1.default.createElement(data_catalog_shared_1.SiteUrlsContext.Consumer, null, function (urls) {
        var text = getTextFromRowData(props.row.data);
        var url = getPathFromRowData(urls, props.row.data);
        if (url) {
            return react_1.default.createElement(LinkCellFormatter, { text: text, pathname: url, noPadding: noPadding, targetBlank: targetBlank, useAnchor: useAnchor });
        }
        else {
            return react_1.default.createElement(data_catalog_shared_1.TextCellFormatter, { text: text, noPadding: noPadding });
        }
    })); };
}
exports.createLinkOrTextCellFormatter = createLinkOrTextCellFormatter;
function createLocationLinkOrTextCellFormatter(getTextFromRowData, getPathFromRowData, noPadding, targetBlank, useAnchor) {
    if (noPadding === void 0) { noPadding = false; }
    if (targetBlank === void 0) { targetBlank = false; }
    if (useAnchor === void 0) { useAnchor = false; }
    return function (props) { return (react_1.default.createElement(data_catalog_shared_1.SiteUrlsContext.Consumer, null, function (urls) {
        var text = getTextFromRowData(props.row.data);
        var url = getPathFromRowData(urls, props.row.data);
        if (url) {
            return react_1.default.createElement(LinkCellFormatter, { text: text, pathname: url, noPadding: noPadding, targetBlank: targetBlank, useAnchor: useAnchor });
        }
        else {
            if (text === LocationTypes_1.LocationTypes.None) {
                return react_1.default.createElement("div", { className: locationCellCssClass },
                    react_1.default.createElement(data_catalog_shared_1.TextCellFormatter, { useWidgetsTooltip: true, cellTitle: Localize_1.Messages.NoneLocationToolTip(), text: Localize_1.Messages.None() }));
            }
            else if (text === LocationTypes_1.LocationTypes.NotApplicable) {
                return react_1.default.createElement("div", { className: locationCellCssClass },
                    react_1.default.createElement(data_catalog_shared_1.TextCellFormatter, { useWidgetsTooltip: true, cellTitle: Localize_1.Messages.NotApplicableLocaitonToolTip(), text: Localize_1.Messages.NotApplicable() }));
            }
            else {
                return react_1.default.createElement(data_catalog_shared_1.TextCellFormatter, { text: text, noPadding: noPadding });
            }
        }
    })); };
}
exports.createLocationLinkOrTextCellFormatter = createLocationLinkOrTextCellFormatter;
//# sourceMappingURL=LinkCellFormatter.js.map